import moment, { Moment } from 'moment'

import { IAppointment } from '../../types'
import { IUpdateAppointmentActivity } from '../thunks/updateAppointmentActivity'

export type TTimeType = 'day' | 'hour'

export const updateAppointmentTime = (
  appointment: IAppointment,
  newMoment: Moment,
  timeType: TTimeType,
): IUpdateAppointmentActivity[] => {
  const timeDifference = moment.duration(
    newMoment
      .clone()
      .set('hour', appointment.startsAt.hours())
      .diff(appointment.startsAt),
  )

  const hourDifference = moment.duration(newMoment.diff(appointment.startsAt))

  const formatDifference =
    timeType === 'day' ? timeDifference.asDays() : hourDifference.asHours()

  return appointment.appointmentActivity.map(activity => ({
    data: {
      id: activity.id,
      personId: activity.personId,
      startsAt: activity.startsAt.clone().add(formatDifference, timeType),
      endsAt: activity.endsAt.clone().add(formatDifference, timeType),
      isLocked: activity.isLocked,
    },
    appointmentUuid: appointment.uuid,
  }))
}
